var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.016,
    height: 52.016,
    viewBox: "0 0 52.016 52.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-close-circle-outline",
    "data-name": "Icon ionic-ios-close-circle-outline",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_229",
    "data-name": "Trazado 229",
    d: "M31.806,28.984l-6.59-6.59,6.59-6.59a2,2,0,0,0-2.826-2.826l-6.59,6.59-6.59-6.59A2,2,0,0,0,12.975,15.8l6.59,6.59-6.59,6.59a1.932,1.932,0,0,0,0,2.826,1.985,1.985,0,0,0,2.826,0l6.59-6.59,6.59,6.59a2.008,2.008,0,0,0,2.826,0A1.985,1.985,0,0,0,31.806,28.984Z",
    transform: "translate(6.993 6.989)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_230",
    "data-name": "Trazado 230",
    d: "M29.383,6.876A22.511,22.511,0,0,1,45.3,45.3,22.511,22.511,0,0,1,13.466,13.466a22.358,22.358,0,0,1,15.917-6.59m0-3.5A26.008,26.008,0,1,0,55.391,29.383,26,26,0,0,0,29.383,3.375Z",
    fill: "#bcbcbc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close_circle.ee6ef994a5f6c6b0a03c0b57eac325be.svg";
export { ForwardRef as ReactComponent };